document.querySelectorAll(".checkout-select-variant").forEach(function(obj) {
	obj.addEventListener("click", function(e) {
		var tabs_menu = obj.closest(".tabs-menu");
		console.log("click", tabs_menu);
		tabs_menu.querySelector(".checkout-select-variant.w--current").classList.remove("w--current");
		obj.classList.add("w--current");
	});
});

document.querySelectorAll(".addtocart_action .btn").forEach(function(obj) {
	obj.addEventListener("click", function(e) {
		e.preventDefault();
		var variant_id = document.querySelector(".checkout-select-variant.w--current").getAttribute("data-variant-id");
		var qty = document.querySelector(".checkout-select-variant.w--current").getAttribute("data-qty");

		let formData = {
		 'items': [{
		  'id': variant_id,
		  'quantity': qty
		  }]
		};
		fetch(window.Shopify.routes.root + 'cart/add.js', {
		  method: 'POST',
		  headers: {
		    'Content-Type': 'application/json'
		  },
		  body: JSON.stringify(formData)
		})
		.then(response => {
		  console.log(response);
		  window.location.href = '/cart';
		  return response.json();
		})
		.catch((error) => {
		  console.error('Error:', error);
		});
	});
});







    /* Get the referrer URL 
    const referrer = document.referrer.toLowerCase();

    // Function to change the announcement bar color
    function changeAnnouncementBarColor() {
      const announcementBar = document.querySelector('.announcement-bar');

      if (referrer.includes('shinearmor.com/email')) {
        announcementBar.style.backgroundColor = 'blue'; // Change to the desired color for email traffic
      } else if (referrer.includes('google')) {
        announcementBar.style.backgroundColor = 'green'; // Change to the desired color for Google traffic
      }
    }

    // Call the function when the page loads
    window.onload = function() {
      changeAnnouncementBarColor();
    };

*/


function toggleDescription() {
  const descriptionHidden = document.querySelector(".description-hidden");
  const showMoreButton = document.getElementById("show-more-button");

  if (descriptionHidden.style.display === "none" || descriptionHidden.style.display === "") {
    descriptionHidden.style.display = "block";
    showMoreButton.textContent = "Show less";
  } else {
    descriptionHidden.style.display = "none";
    showMoreButton.textContent = "Show more";
  }
}